import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TypeaheadMatch } from 'ngx-bootstrap';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { ManageSkillsService } from 'src/app/core/services/manage-skills.service';
import { RequisitionSkill } from 'src/app/core/models/requisitionSkill';
import { AngularModalService } from 'src/app/core/services/modal.service';
declare var bootbox: any;

@Component({
    selector: 'app-add-edit-candidate-skill',
    templateUrl: './add-edit-candidate-skill.component.html',
    styleUrls: ['./add-edit-candidate-skill.component.css']
})
export class AddEditCandidateSkillComponent implements OnInit {

    @Input() userId;
    @Input() skills;
    @Input() skillType;
    @Input() context;
    @Input() mode;
    @Input() currentSkills;
    @Input() originalSkills;
    @Input() allExistingSkills;
    @Input() allExistingDegrees;
    @Input() allExistingFieldOfStudy;
    @Input() allExistingRoles;
    @Input() allExistingCertificates;
    @Input() allExistingJDActionWords;
    @Input() requisitionSkills;
    @Input() timePeriods;
    @Input() isViewOnly;
    @Input() isJobProfile;
    @Output() saveCallback = new EventEmitter<any>();
    @Output() cancelCallback = new EventEmitter<any>();
    @Output() setOtherSkillsCallback = new EventEmitter<any>();
    @Output() setSkillsAsPerCategoryCallback = new EventEmitter<any>();

    skillHeading: any;
    skillsCopy: any;
    selected: any = undefined;
    searchResults: any = [];
    selectedSkillType: any;
    skillTypes: any = [];
    skillsTimePeriods: any = [];
    allSkills: any;
    skillsTypeAheadList: any = [];
    ranges: any = [];
    resetSkillsList: any = [];
    educationFieldOfStudy: any = [];
    experienceRoles: any = [];
    draggable: any;
    addNewSkill: any;
    addNewSkillObj: any;
    isEditSkills: boolean = false;
    viewSkillDetails: boolean = true;
    expandSkills: boolean;
    isRemoveSectionActive: boolean = false;

    searchCertificationText: any = '';
    searchCertificates: any;
    searchEducationText: any = '';
    searchEducations: any;
    searchExperienceText: any = '';
    searchExperiences: any;
    searchSkillText: any = '';
    searchSkills: any;
    existingDuplicateSkillName: any = {};
    sections: any = [[new RequisitionSkill('')]];
    public certificationsObservable: Observable<any[]>;
    public educationObservable: Observable<any[]>;
    public experienceObservable: Observable<any[]>;
    public skillsObservable:  Observable<any[]>;

    constructor(
        private alertsAndNotificationsService: AlertAndNotificationsService,
        private skillsService: ManageSkillsService,
        private modalService: AngularModalService
    ) {
    }

    ngOnChanges(changes) {
        if (changes && changes.allExistingSkills && !changes.allExistingSkills.firstChange && changes.allExistingSkills.currentValue && changes.allExistingSkills.previousValue) {
            if (changes.allExistingSkills.currentValue.length != changes.allExistingSkills.previousValue) {
                this.setAllExistingSkills(changes.allExistingSkills.currentValue);
            }
        }

        if (changes && changes.skills && !changes.skills.firstChange && changes.skills.currentValue && changes.skills.previousValue) {
            if (changes.allExistingSkills && (changes.allExistingSkills.currentValue.length != changes.allExistingSkills.previousValue)) {
                this.skillsCopy = this.skills.slice(0,);
            }
        }
    }

    ngOnInit() {
        this.skills = this.skills ? this.skills : [];
        this.skills.forEach(skill => {
            skill.range = skill.range ? skill.range : "",
            skill.plusTo = skill.plusTo ? skill.plusTo : ""
        });
        this.skillHeading = this._getSkillsHeading();
        this.skillsCopy = angular.copy(this.skills);
        // if (this.mode && this.mode === 'edit') {
        //     this.isEditSkills = true;
        // }
        this._setAllSkills();
        this.selectedSkillType = "education";
        this.skillTypes = [
            { name: "Education", value: "education" },
            { name: "Experience", value: "experience" },
            { name: "Technical Skills", value: "technical" },
            { name: "Operational Skills", value: "operational" },
            { name: "Soft Skills", value: "soft" },
            { name: "Other", value: "other" },
            { name: "Certifications", value: "certifications" },
        ];
        let skills = {
            education: [],
            experience: [],
            technical: [],
            operational: [],
            soft: [],
            other: [],
            certifications: []
        };
        this.currentSkills = angular.copy(skills);
        this.originalSkills = angular.copy(skills);

        this._massageSkillsData();
        this.ranges = [
            { name: "", value: "" },
            { name: "Atleast", value: "atleast" },
            { name: "Min", value: "min" },
            { name: "Max", value: "max" }
        ];
        this.resetSkillsList = [...this.skills];
        this.setSkillsObservable();
        this.isEditSkills = true; // New Change
    }

    setSkillsObservable() {
        this.certificationsObservable = this.skillsService.createSkillObservable(
            'certification',
            () => this.searchCertificationText,
            this.allExistingCertificates
        );

        this.educationObservable = this.skillsService.createSkillObservable(
            'education',
            () => this.searchEducationText,
            {
                degrees: this.allExistingDegrees,
                fieldOfStudy: this.allExistingFieldOfStudy
            }
        );

        this.experienceObservable = this.skillsService.createSkillObservable(
            'experience',
            () => this.searchExperienceText,
            {
                fieldOfStudy: this.allExistingFieldOfStudy,
                roles: this.allExistingRoles,
                timePeriods: this.timePeriods
            }
        );

        this.skillsObservable = this.skillsService.createSkillObservable(
            'skills',
            () => this.searchSkillText,
            {
                skills: this.allExistingSkills,
                skillsTimePeriods: this.timePeriods
            }
        );
    }

    onSearchCertificationChange(searchCertificationText: string): void {
        this.searchCertificationText = searchCertificationText;
    }

    onSearchEducationChange(searchEducationText: string): void {
        this.searchEducationText = searchEducationText;
    }

    onSearchExperienceChange(searchExperienceText: string): void {
        this.searchExperienceText = searchExperienceText;
    }

    onSearchSkillChange(searchSkillText: string, skill: any): void {
        this.searchSkillText = searchSkillText;

        if (!searchSkillText || searchSkillText.trim() === '') return;

        // Find the longest matching time period in the typed text
        const timePeriodObj = this.timePeriods
            ? this.timePeriods
                .filter(tp => searchSkillText.toLowerCase().includes(tp.name.toLowerCase()))
                .sort((a, b) => b.name.length - a.name.length)[0]
            : null;

        if (timePeriodObj) {
            const typeAheadValue = timePeriodObj.value;
            skill.minExperienceInMonths = typeAheadValue.minExperienceInMonths;
            skill.maxExperienceInMonths = typeAheadValue.maxExperienceInMonths;
            skill.range = typeAheadValue.range;
            skill.plusTo = typeAheadValue.plusTo;

            const safePattern = timePeriodObj.name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const skillName = searchSkillText.replace(new RegExp(safePattern, 'i'), '').trim();

            const existingSkill = this.allExistingSkills && skillName
                ? this.allExistingSkills.filter(s => s.skill.toLowerCase() === skillName.toLowerCase())[0]
                : null;
            skill.skill = existingSkill ? existingSkill : (skillName ? { skill: skillName } : null);
            skill.competency = existingSkill ? existingSkill.skill : (skillName || searchSkillText);
        } else {
            skill.competency = searchSkillText;
            skill.skill = null;
            skill.minExperienceInMonths = '';
            skill.maxExperienceInMonths = '';
            skill.range = '';
            skill.plusTo = '';
        }
    }

    setSkillsCompetency(type, skill) {
        if (type === 'skill') {
            if (skill && skill.displayName && skill.displayName != '') {
                if (!skill.competency || skill.competency === '') {
                    let competencySkill = this.allExistingSkills.filter(existingSkill => skill.displayName.toLowerCase().includes(existingSkill.skill.toLowerCase()))[0];
                    skill.competency = competencySkill && competencySkill.skill ? competencySkill.skill : skill.displayName;
                } else {
                    skill.competency = skill.displayName;
                }
            }
        }
    }

    _setTypeAheadList(type) {
        switch (type) {
            case 'skills':
                return this.allSkills.allExistingSkills;
            default:
                return this.allSkills.other;
        }
    }

    _getSkillsHeading() {
        switch (this.skillType) {
            case "education":
                return "Education";
            case "experience":
                return "Experience";
            case "technical":
                return "Technical Skills";
            case "operational":
                return "Operational Skills";
            case "soft":
                return "Soft Skills";
            case "other":
                return "Other";
            case "certification":
                return "Certifications"
            default:
                return "Technical Skills";
        }
    }

    _setAllSkills() {
        this.allSkills = {
            education: [],
            department: [],
            experience: [],
            certifications: []
        };

        if (this.allExistingSkills && this.allExistingSkills.length > 0) {
            this.allExistingSkills.forEach(skill => {
                skill.competency = skill.skill;
            });
            this.setAllExistingSkills(this.allExistingSkills);
        } else {
            this.setAllExistingSkills(null);
        }
    }


    _massageSkillsData() {
        angular.forEach(this.skillTypes, (type, key) => {
            angular.forEach(this.allSkills[type.value], (skill, key) => {
                this._setSkillDisplayValue(skill);
            });
            angular.forEach(this.skills[type.value], (skill, key) => {
                this._setSkillDisplayValue(skill);
            });
            angular.forEach(this.currentSkills[type.value], (skill, key) => {
                this._setSkillDisplayValue(skill);
            });
            angular.forEach(this.originalSkills[type.value], (skill, key) => {
                this._setSkillDisplayValue(skill);
            });
        });
    }

    _setSkillDisplayValue(skill) {
        var skillDisplayValue = "";
        skillDisplayValue = skillDisplayValue + skill.name;
        skill.skillDisplayValue = skillDisplayValue;
    }

    convertMonthsToYearsText(periodValue, skill, displayName) {
        const wordToNumber = {
            "one": 1,
            "two": 2,
            "three": 3,
            "four": 4,
            "five": 5,
            "six": 6,
            "seven": 7,
            "eight": 8,
            "nine": 9,
            "ten": 10,
            "eleven": 11,
            "twelve": 12
        };
    
        // Regex to capture numeric or word-based months, with optional 'plus'/'+' or "At least/Minimum/Maximum"
        let monthsPattern = /(?:Atleast|Minimum|Maximum)?\s*(\d+|one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve)\s*(?:\+|plus)?\s*month(?:s)?/i;
    
        let match = displayName.match(monthsPattern);
        
        if (match) {
            let monthsString = match[1].toLowerCase();
            let months = isNaN(monthsString) ? wordToNumber[monthsString] : parseInt(monthsString);  // Convert word to number or use the numeric value
    
            let prefix = '';
            let suffix = '';
            
            // Check for "Atleast", "Minimum", "Maximum" and append them to the prefix
            if (/Atleast/i.test(displayName)) {
                prefix = 'Atleast ';
            } else if (/Minimum/i.test(displayName)) {
                prefix = 'Minimum ';
            } else if (/Maximum/i.test(displayName)) {
                prefix = 'Maximum ';
            }
    
            // Adjust for "plus" or "+" indicating additional months and update suffix
            if (match[0].includes('plus') || match[0].includes('+')) {
                suffix = ' +'; // Add the plus suffix
            }
    
            let years = (months / 12).toFixed(1);  // Convert months to years and round to 1 decimal place
    
            // Extract the skill from the displayName by removing the matched time period
            let skillName = displayName.replace(match[0], '').trim();
    
            return `${prefix}${years}${suffix} years ${skillName}`;
        } else {
            return '';
        }
    }

    onSkillSelect(e: TypeaheadMatch): void {
        this._addSkill(e);
        this.addNewSkillObj = e.item;
    }

    _addSkill(selectedSkill) {
        if (selectedSkill.id !== undefined) {
            this._setSkillDisplayValue(selectedSkill);
            this.selected = undefined;
        }
    }

    setFocusToNextElement(type, inputEvent, isLastElement) {
        let baseId;
        let currentIndex;
        if(type === 'onAddSkill') {
            baseId = (inputEvent === 'skillsInput') ? (inputEvent + this.skillType) : inputEvent;
            currentIndex = this.skills.length - 1;
        } else {
            inputEvent.blur();
            baseId = inputEvent.id.split('-')[0];
            currentIndex = parseInt(inputEvent.id.split('-')[1]);
        }
        let nextIndex = currentIndex + 1;
        let nextId = `${baseId}-${!isLastElement ? nextIndex : (this.skills.length - 1)}`;
        let nextElement = document.getElementById(nextId);
        if (nextElement) {
            nextElement.focus();
        }
    }

    checkAndAddNewSkill(type, inputEvent, inputText, skill, index) {
        if (index == null || index == undefined || !this.isSkillExists(inputText, index)) {
            let checkIfEmptyInputFieldExists = this.skills.filter(skill => (!skill.displayName || skill.displayName == ''));
            if(checkIfEmptyInputFieldExists && checkIfEmptyInputFieldExists.length > 0) {
                setTimeout(() => {
                    this.setFocusToNextElement(type, inputEvent, true);
                }, 100);
                if(type === 'onAddSkill') {
                    this.displayEmptySkillMessage();
                }
            } else {
                if(this.checkIfSkillExists(skill, inputText)) {
                    this.onAddSkill(type, skill, inputText, inputEvent);
                } else {
                    if (type === 'onAddSkill') {
                        this.skills.push(new RequisitionSkill(''));
                    } else {
                        this.displayEmptySkillMessage();
                    }
                }
                
            }
        } else {
            this.displayExistingSkillMessage(inputText, this.existingDuplicateSkillName, () => {
                skill.displayName = '';
                inputText = '';
            });
        }
    };

    checkIfSkillExists(skill, inputText) {
        // Remove 'this.skillType != 'experience'' condition if want to check experience filed of study/role.
        if(this.skillType != 'education' && this.skillType != 'certification' && this.skillType != 'experience') {
            let timePeriodObj = this.timePeriods.filter(timePeriod => inputText.includes(timePeriod.name)).sort((a, b) => b.name.length - a.name.length)[0];
            let existingSkillName = timePeriodObj ? inputText.replace(timePeriodObj.name, '').trim() : inputText;
            return (existingSkillName && existingSkillName != '') ? true : false;
        } else {
            return true;
        }
    }

    newSkill(inputText: string, type: string, inputEvent: any, skill, index) {
        if (inputText && inputText !== '') {
            if (skill.typeAheadSelected && (skill.oldDisplaySkillName != skill.displayName)) {
                this.expandSkills = true;
                skill.typeAheadSelected = false;
                skill.oldDisplaySkillName = skill.displayName.slice();
            } else {
                this.expandSkills = true;
                this.checkAndAddNewSkill(type, inputEvent, inputText, skill, index);
            }
        } else {
            if (type === 'onEnter') {
                this.displayEmptySkillMessage();
            } else {
                this.expandSkills = true; 
                this.checkAndAddNewSkill(type, inputEvent, inputText, skill, index);
            }
        }
    }    

    displayEmptySkillMessage() {
        if (this.skillType === 'technical' || this.skillType === 'operational' || this.skillType === 'soft' || this.skillType === 'other') {
            this.alertsAndNotificationsService.showAlertWithCallBack('Skill Empty', "Enter Skill to Add", 'warning', () => {
                if (this.isJobProfile) {
                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        } else {
            const title = this.skillType === 'education' ? 'Education' : this.skillType === 'experience' ? 'Experience' : 'Certification';
            this.alertsAndNotificationsService.showAlertWithCallBack(`${title} Empty`, `Enter ${title} to Add`, 'warning', () => {
                if (this.isJobProfile) {
                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        }
    }

    _setNewItem(newItem: any) {
        return newItem && newItem.id ? {
            ...newItem,
            competency: newItem.skill || newItem.name
        } : {
            id: null,
            name: this.addNewSkill,
            range: '',
            competency: this.addNewSkill,
            mandatory: false,
            favorite: false,
            experience: { years: 0, months: 0 }
        };
    }

    setSkillsCopy(skills) {
        this.skillsCopy = skills.slice(0,);
    }

    onAddSkill(type, skill, inputText, inputEvent) {
        if (this.skillType === 'technical' || this.skillType === 'operational' || this.skillType === 'soft' || this.skillType === 'other') {
            let timePeriodObj = this.timePeriods.filter(timePeriod => (inputText.length > timePeriod.name.length) && (inputText.includes(timePeriod.name))).sort((a, b) => b.name.length - a.name.length)[0];
            // Check if input text has any of existing skills
            let existingSkillName = timePeriodObj ? inputText.replace(timePeriodObj.name, '').trim() : inputText;
            let existingSkill = this.allExistingSkills.filter(skill => 
                existingSkillName.toLowerCase() === skill.skill.toLowerCase()
            );

            if(!existingSkill || existingSkill.length === 0) {
                let newSkill = this.skills.filter(skill => skill.displayName === inputText)[0];
                newSkill.skill = {skill: existingSkillName};
                this.skills.push(new RequisitionSkill(''));
                setTimeout(() => {
                    this.setFocusToNextElement(type, inputEvent, false);
                }, 100);
            } else {
                if(existingSkill[0].category.toLowerCase() != this.skillType) {
                    let newSkill = this.skills.filter(skill => skill.displayName === inputText);
                    this.skills.push(new RequisitionSkill(''));
                    setTimeout(() => {
                        this.setFocusToNextElement(type, inputEvent, false);
                    }, 100);
                } else {
                    this.skills.push(new RequisitionSkill(''));
                    setTimeout(() => {
                        this.setFocusToNextElement(type, inputEvent, false);
                    }, 100);
                }
            }
            if(this.skills.length === 0) {
                this.skills.push(new RequisitionSkill(''));
            }
        } else {
            this.skills.push(new RequisitionSkill(''));
            setTimeout(() => {
                this.setFocusToNextElement(type, inputEvent, false);
            }, 100);
        }
    }

    onSkillUpdate(skillToUpdate) {
        this._setSkillDisplayValue(skillToUpdate);
        var skillIndex = _.findIndex(this.skills[this.selectedSkillType], (skill: any) => {
            return skillToUpdate.id === skill.id && skillToUpdate.skillDisplayValue === skill.skillDisplayValue;
        });
        this.skills[this.selectedSkillType].splice(skillIndex, 1, skillToUpdate);
    }

    onDeleteSkill(skill) {
        this._deleteSkill(skill);
        if (this.allSkills.allExistingSkills) {
            this.allSkills.allExistingSkills = this.allSkills.allExistingSkills.push(skill);
        }
    }

    _deleteSkill(skillToDelete) {
        _.remove(this.skills[this.selectedSkillType], (skill: any) => {
            return skillToDelete.id == skill.id && skillToDelete.skillDisplayValue == skill.skillDisplayValue;
        });
    }

    onResetSkillsClick(resetType) {
        var message = "";
        if (resetType == "previous") {
            message = "Going back to Requisition Detail of version saved previously. Are you sure to continue?";
        } else if (resetType == 'original') {
            message = "Going back to Requisition Detail of version saved when Requisition was ‘Activated’. Are you sure to continue?";
        }
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
            message: message,
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: (result) => {
                if (result) {
                    this._resetSkill(resetType);
                }
            }
        });
    }

    _resetSkill(resetType) {
        if (resetType == "previous") {
            this.skills = angular.copy(this.currentSkills);
        } else if (resetType == "original") {
            this.skills = angular.copy(this.originalSkills);
        }
    }

    toggleDetailsView() {
        this.viewSkillDetails = !this.viewSkillDetails;
    }

    enter() {
        console.log(this.selected);
        var selectedSkill = { id: 10, name: this.selected, mandatory: false, favorite: false, experience: { years: 0, months: 0 } };
        this._setSkillDisplayValue(selectedSkill);
        this.skills[this.selectedSkillType].push(selectedSkill);
        this.selected = undefined;
    }

    setAllExistingSkills(allSkills) {
        // let existingSkillsIds = this.skills ? this.skills.map(skill => { return skill.id }) : [];
        // if (this.allExistingSkills) {
        //     this.allExistingSkills = this.allExistingSkills.filter(skill => {
        //         if (!existingSkillsIds.includes(skill.id)) {
        //             return true;
        //         }
        //     });
        // }
        if (allSkills) {
            this.allSkills.allExistingSkills = [...this.allExistingSkills];
        } else {
            this.allSkills.allExistingSkills = [];
        }
    }

    editSkills() {
        this.isEditSkills = !this.isEditSkills;
        if (this.skillType === 'certification') {
            this.skills = this.skills.filter(skill => skill.displayName && skill.displayName != '');
            this.skills.forEach(skill => {
                skill = this.setCertificate(skill);
            });
        } else if (this.skillType === 'education') {
            this.skills = this.skills.filter(skill => skill.displayName && skill.displayName != '');
            this.skills.forEach(skill => {
                skill = this.setEducation(skill);
            });
        } else if (this.skillType === 'experience') {
            this.skills = this.skills.filter(skill => skill.displayName && skill.displayName != '');
            this.skills.forEach(skill => {
                skill = this.setExperience(skill);
            });
        } else {
            this.skills = this.skills.filter(skill => skill.displayName && skill.displayName != '');
            this.skills.forEach(skill => {
                skill = this.setSkills(skill);
            });
        }

        if (this.skillsCopy.length === this.skills.length) {
            this.resetSkillsList = [...this.skills];
        } else {
            const deletedSkills = this.skillsCopy.filter(element =>
                !this.skills.some(skill => (skill.id && skill.id === element.id) || (skill.skill === element.skill))
            );
            if (this.skillType != 'certification' && this.skillType != 'education' && this.skillType != 'experience') {
                this.allExistingSkills = [...this.allExistingSkills, ...deletedSkills];
            }
            this.resetSkillsList = [...this.skills];
        }

        if (this.skillType != 'certification' && this.skillType != 'education' && this.skillType != 'experience') {
            this.setAllExistingSkills(this.allExistingSkills);
        }

        if (this.saveCallback) {
            this.saveCallback.emit(this.allExistingSkills);
        }

    }

    deleteSkill(index) {
        this.skills.splice(index, 1);
    }

    onCandidateSkillUpdate(skillIndex, skillToUpdate, skillPriority) {
        if (skillPriority == 'mandatory' && skillToUpdate.favorite == true) {
            skillToUpdate.favorite = false;
        } else if (skillPriority == 'favorite' && skillToUpdate.mandatory == false) {
            skillToUpdate.favorite = true;
        }

        this.skills.splice(skillIndex, 1, skillToUpdate);
    }

    resetSkills() {
        this.skills = [...this.resetSkillsList];
        this.editSkills();
    }

    updateMandatory(skill) {
        skill.mandatory = !skill.mandatory;
        if (skill.mandatory) {
            skill.niceToHave = false;
            skill.preferred = false;
        }
    }

    updateNiceToHave(skill) {
        skill.niceToHave = !skill.niceToHave;
        if (skill.niceToHave) {
            skill.mandatory = false;
            skill.preferred = false;
        }
    }

    updatePreferred(skill) {
        skill.preferred = !skill.preferred;
        if (skill.preferred) {
            skill.mandatory = false;
            skill.niceToHave = false;
        }
    }

    onEditSkill() {
        this.isEditSkills = !this.isEditSkills;
        this.resetSkillsList = [...this.skills];
    }

    onRequisitionSkillSelect(e: TypeaheadMatch, skill, inputElement: HTMLInputElement, index): void {
        skill.typeAheadSelected = true;
        skill.displayName = e.item.displayName ? e.item.displayName : e.item.name;
        if (index == null || index == undefined || !this.isSkillExists(skill.displayName, index)) {
            if (this.skillType === 'education') {
                skill.degreeName = e.item.degreeName ? e.item.degreeName : "";
                skill.fieldOfStudy = e.item.fieldOfStudy ? e.item.fieldOfStudy : "";
            } else if (this.skillType === 'certification') {
                skill.certificationGroup = e.item.certificationGroup ? e.item.certificationGroup : "";
                skill.certificationSkill = e.item.certificationSkill ? e.item.certificationSkill : "";
            } else {
                skill.skill = e.item.skill ? e.item.skill : null;
                skill.range = e.item.range;
                skill.plusTo = e.item.plusTo;
                skill.minExperienceInMonths = e.item ? e.item.minExperienceInMonths : "";
                skill.maxExperienceInMonths = e.item ? e.item.maxExperienceInMonths : "";
                skill.experienceInMonths = e.item ? e.item.months : "";
                if(this.skillType === 'experience') {
                    skill.competency = e.item.role;
                    skill.role = e.item.role;
                    skill.preposition = e.item.preposition;
                } else {
                    skill.competency = e.item.skill ? e.item.skill.skill : null;
                    skill.actionWord = e.item ? e.item.actionWord : null;
                }
            }
            
            setTimeout(() => {
                if (inputElement) {
                    inputElement.focus(); // Refocus input
                    const length = inputElement.value.length;
                    inputElement.setSelectionRange(length, length); // Move cursor to end
                }
            }, 0);
        } else {
            this.displayExistingSkillMessage(skill.displayName, this.existingDuplicateSkillName, () => {
                skill.displayName = '';
            });
        }
    }

    setCertificate(certificate) {
        if (certificate.displayName.includes(" in ")) {
            let degreesAndFieldOfStudy = certificate.displayName.split(" in ");
            certificate.degreeName = degreesAndFieldOfStudy[0] ? degreesAndFieldOfStudy[0] : "";
            certificate.fieldOfStudy = degreesAndFieldOfStudy[1] ? degreesAndFieldOfStudy[1] : "";
        } else if (certificate.displayName.includes(" in")) {
            let degreesAndFieldOfStudy = certificate.displayName.split(" in");
            certificate.degreeName = degreesAndFieldOfStudy[0] ? degreesAndFieldOfStudy[0] : "";
            certificate.fieldOfStudy = "";
        } else {
            certificate.degreeName = certificate.displayName;
            certificate.fieldOfStudy = "";
        }
    }

    setEducation(education) {
        if (education.displayName.includes(" in ") && !education.displayName.includes("or equivalent experience")) {
            let degreesAndFieldOfStudy = education.displayName.split(" in ");
            education.degreeName = degreesAndFieldOfStudy[0] ? degreesAndFieldOfStudy[0] : "";
            education.fieldOfStudy = degreesAndFieldOfStudy[1] ? degreesAndFieldOfStudy[1] : "";
        } else if (education.displayName.includes(" in") && !education.displayName.includes("or equivalent experience")) {
            let degreesAndFieldOfStudy = education.displayName.split(" in");
            education.degreeName = degreesAndFieldOfStudy[0] ? degreesAndFieldOfStudy[0] : "";
            education.fieldOfStudy = "";
        } else {
            education.degreeName = education.displayName;
            education.fieldOfStudy = "";
        }
    }

    setExperience(experience) {
        let timePeriodObj = this.timePeriods.filter(timePeriod => (experience.displayName.length > timePeriod.name.length) && (experience.displayName.includes(timePeriod.name))).sort((a, b) => b.name.length - a.name.length)[0];
        let addMonthsText = (timePeriodObj &&  timePeriodObj.value.months > 0) ? this.convertMonthsToYearsText(timePeriodObj.value, '', experience.displayName) : '';
            experience.convertedDisplayName = addMonthsText;
        if (timePeriodObj) {
            let typeAheadValue = timePeriodObj.value;
            experience.minExperienceInMonths = typeAheadValue.minExperienceInMonths;
            experience.maxExperienceInMonths = typeAheadValue.maxExperienceInMonths;
            experience.range = typeAheadValue.range;
            experience.plusTo = typeAheadValue.plusTo;
            experience.competency = experience.displayName.replace(timePeriodObj, "");
            experience.title = experience.displayName.replace(timePeriodObj, "");
        } else {
            experience.competency = experience.displayName;
            experience.title = experience.displayName;
            experience.minExperienceInMonths = "";
            experience.maxExperienceInMonths = "";
            experience.range = "";
            experience.plusTo = "";
        }
    }

    setSkills(skill) {
        const timePeriodObj = this.timePeriods
            ? this.timePeriods
                .filter(tp => (skill.displayName.length > tp.name.length) && skill.displayName.toLowerCase().includes(tp.name.toLowerCase()))
                .sort((a, b) => b.name.length - a.name.length)[0]
            : null;
        if (timePeriodObj) {
            let typeAheadValue = timePeriodObj.value;
            skill.minExperienceInMonths = typeAheadValue.minExperienceInMonths;
            skill.maxExperienceInMonths = typeAheadValue.maxExperienceInMonths;
            skill.range = typeAheadValue.range;
            skill.plusTo = typeAheadValue.plusTo;
            const safePattern = timePeriodObj.name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            skill.competency = skill.displayName.replace(new RegExp(safePattern, 'i'), '').trim();
        } else {
            skill.competency = skill.displayName;
            skill.jdActionWord = "";
            skill.minExperienceInMonths = "";
            skill.maxExperienceInMonths = "";
            skill.range = "";
            skill.plusTo = "";
        }
    }

    newSection() {
        this.sections.push([new RequisitionSkill('')]);
        this.isRemoveSectionActive = this.sections.length > 1;
    }

    removeSection(index) {
        this.sections.splice(index,1);
        this.isRemoveSectionActive = this.sections.length > 1;
    }

    changeSkillPriority(skill, priority) {
        skill.priority = priority;
    }

    isSkillExists(displayName: string, index): boolean {
        this.existingDuplicateSkillName = {};
        if (!displayName || displayName.trim() === '') return false;

        if (this.skillType === 'education') {
            return this.checkEducationExists(displayName, index);
        }

        if (this.skillType === 'experience') {
            return this.checkExperienceExists(displayName, index);
        }

        if (this.skillType === 'certification') {
            return this.checkCertificationExists(displayName, index);
        }

        return this.checkSkillsExists(displayName, index);
    }

    checkEducationExists(displayName: string, index): boolean {
        const skillName = displayName.trim().toLowerCase();
        const skills = this.skills;
        if (!skillName || !skills || !this.allExistingDegrees || !this.allExistingFieldOfStudy) return false;

        const skillsToCheck = this.skills.length > 0
            ? this.skills.filter((skill, key) =>
                key !== index && skill.displayName && skill.displayName.trim() !== '')
            : [];

        const knownDegrees = this.allExistingDegrees.map(function (d) {
            return d.degreeName.toLowerCase();
        });

        const knownFields = this.allExistingFieldOfStudy.map(function (f) {
            return f.fieldOfStudy.toLowerCase();
        });

        function normalizeTerm(str) {
            return str.replace(/ or equivalent( experience)?( in related field)?$/i, '').trim().toLowerCase();
        }

        let inputDegree = '';
        let inputField = '';
        let originalDegree = '';
        let originalField = '';

        if (skillName.toLowerCase().indexOf(' in ') !== -1) {
            const inIndex = skillName.toLowerCase().indexOf(' in ');
            const firstPart = skillName.substring(0, inIndex).trim();
            const secondPart = skillName.substring(inIndex + 4).trim();
            originalDegree = firstPart;
            originalField = secondPart;
            inputDegree = normalizeTerm(originalDegree);
            inputField = normalizeTerm(originalField);
        } else {
            const normalized = normalizeTerm(skillName);
            if (knownDegrees.indexOf(normalized) !== -1) {
                inputDegree = normalized;
            } else if (knownFields.indexOf(normalized) !== -1) {
                inputField = normalized;
            } else {
                inputDegree = normalized;
            }
        }

        for (let i = 0; i < skillsToCheck.length; i++) {
            const item = skillsToCheck[i];

            const itemDisplayName = item.displayName.trim().toLowerCase();
            const existingDegree = item.degreeName ? normalizeTerm(item.degreeName.trim().toLowerCase()) : '';
            const existingField = item.fieldOfStudy ? normalizeTerm(item.fieldOfStudy.trim().toLowerCase()) : '';

            // 1. Exact displayName match
            if (itemDisplayName === skillName) {
                this.existingDuplicateSkillName = {
                    name: skillName,
                    type: 'education',
                    label: 'Education'
                };
                return true;
            }

            // 3. Entered only a degree - block if any skill has same degree with any FOS
            if (inputDegree && !inputField) {
                if (existingDegree === inputDegree && existingField) {
                    this.existingDuplicateSkillName = {
                        name: inputDegree,
                        type: 'education',
                        label: 'Education'
                    };
                    return true;
                }
            }

            // 4. Entered only FOS - block if same FOS exists in a skill with any degree
            if (!inputDegree && inputField) {
                if (existingField === inputField && existingDegree) {
                    this.existingDuplicateSkillName = {
                        name: inputField,
                        type: 'education',
                        label: 'Field Of Study'
                    };
                    return true;
                }
            }

            // 5. Input has both degree and FOS - block if same degree exists alone or with any other FOS
            if (inputDegree && inputField) {
                if (existingDegree === inputDegree) {
                    this.existingDuplicateSkillName = {
                        name: inputDegree,
                        type: 'education',
                        label: 'Education'
                    };
                    return true;
                }

                if (existingField === inputField && !existingDegree) {
                    this.existingDuplicateSkillName = {
                        name: inputField,
                        type: 'education',
                        label: 'Field Of Study'
                    };
                    return true;
                }
            }
        }

        return false;
    }

    checkCertificationExists(displayName: string, index): boolean {
        if (!displayName || !this.skills) return false;

        const inputRaw = displayName.trim().toLowerCase();

        const skillsToCheck = this.skills.length > 0
            ? this.skills.filter((skill, key) =>
                key !== index && skill.displayName && skill.displayName.trim() !== '')
            : [];

        // Extract core name from input
        let cleanedInput = inputRaw;
        const inIndex = cleanedInput.lastIndexOf(' in ');
        if (inIndex !== -1) {
            cleanedInput = cleanedInput.substring(inIndex + 4).trim();
        }

        if (!cleanedInput || cleanedInput.length < 2) {
            return false;
        }

        // Loop through existing entered skills
        for (let i = 0; i < skillsToCheck.length; i++) {
            const skill = skillsToCheck[i];
            if (!skill || !skill.displayName) continue;

            const existingRaw = skill.displayName.trim().toLowerCase();
            let cleanedExisting = existingRaw;
            const existingInIndex = existingRaw.lastIndexOf(' in ');
            if (existingInIndex !== -1) {
                cleanedExisting = existingRaw.substring(existingInIndex + 4).trim();
            }

            const isDuplicate =
                cleanedInput === cleanedExisting ||
                inputRaw === existingRaw ||
                cleanedInput === existingRaw ||
                cleanedExisting === inputRaw ||
                cleanedInput.includes(cleanedExisting) ||
                cleanedExisting.includes(cleanedInput);

            if (isDuplicate) {
                this.existingDuplicateSkillName = {
                    name: cleanedExisting,
                    type: 'certification',
                    label: 'Certification'
                };
                return true;
            }
        }

        return false;
    }

    checkSkillsExists(displayName: string, index): boolean {
        if (!this.requisitionSkills || !this.timePeriods) return false;
    
        const timePeriodObj = this.timePeriods
            .filter(tp => displayName.toLowerCase().indexOf(tp.name.toLowerCase()) !== -1)
            .sort((a, b) => b.name.length - a.name.length)[0];
    
        let skillName = displayName;
    
        // Strip JD action word prefixes (longest match first)
        if (this.allExistingJDActionWords.length) {
            const prefixVariants = this.allExistingJDActionWords.flatMap(word => {
                const base = word.actionword.trim().toLowerCase();
                return [base, ...['in', 'with', 'of', 'at'].map(suffix => `${base} ${suffix}`)];
            }).sort((a, b) => b.length - a.length); // Longest first
    
            const lowerDisplay = skillName.toLowerCase();
            const matchingPrefix = prefixVariants.find(prefix => lowerDisplay.startsWith(prefix + ' '));
    
            if (matchingPrefix) {
                const regex = new RegExp('^' + matchingPrefix + '\\s+', 'i');
                skillName = skillName.replace(regex, '');
            }
        }
    
        // Strip time period if present
        if (timePeriodObj) {
            const safePattern = this.escapeRegExp(timePeriodObj.name);
            skillName = skillName.replace(new RegExp(safePattern, 'i'), '');
        }
    
        skillName = skillName.trim().toLowerCase();
        if (!skillName) return false;
    
        const skillCategories = [
            { key: 'technicalSkills', label: 'Technical Skills' },
            { key: 'operationalSkills', label: 'Operational Skills' },
            { key: 'softSkills', label: 'Soft Skills' },
            { key: 'otherSkills', label: 'Other Skills' }
        ];
    
        for (let i = 0; i < skillCategories.length; i++) {
            const category = skillCategories[i];
            const skillList = this.requisitionSkills[category.key];
    
            if (skillList && Array.isArray(skillList)) {
                let listToCheck = skillList;
    
                if (this.skillType && category.key === this.skillType + 'Skills' && skillList.length > 0) {
                    listToCheck = skillList.filter((skill, key) =>
                        key !== index && skill.displayName && skill.displayName.trim() !== '');
                }
    
                const match = listToCheck.some(skill => {
                    if (!skill.displayName) return false;
    
                    let existingSkillName = skill.displayName.trim().toLowerCase();
    
                    const existingTimePeriod = this.timePeriods
                        .filter(tp => existingSkillName.indexOf(tp.name.toLowerCase()) !== -1)
                        .sort((a, b) => b.name.length - a.name.length)[0];
    
                    if (existingTimePeriod) {
                        let safePattern = this.escapeRegExp(existingTimePeriod.name);
                        existingSkillName = existingSkillName.replace(new RegExp(safePattern, 'i'), '').trim();
                    }
    
                    return existingSkillName === skillName;
                });
    
                if (match) {
                    this.existingDuplicateSkillName = {
                        name: skillName,
                        type: category.key.replace('Skills', ''),
                        label: category.label
                    };
                    return true;
                }
            }
        }
    
        return false;
    } 

    checkExperienceExists(displayName: string, index): boolean {
        if (
            !displayName ||
            !this.skills ||
            !this.allExistingRoles ||
            !this.allExistingFieldOfStudy ||
            !this.timePeriods
        ) return false;

        const inputValue = displayName.trim().toLowerCase();
        const skillsToCheck = this.skills.length > 0
            ? this.skills.filter((skill, key) =>
                key !== index && skill.displayName && skill.displayName.trim() !== '')
            : [];


        // Check for exact displayName match
        const exactMatch = skillsToCheck.some(item =>
            item.displayName && item.displayName.trim().toLowerCase() === inputValue
        );

        if (exactMatch) {
            this.existingDuplicateSkillName = {
                name: inputValue,
                type: 'experience',
                label: 'Experience'
            };
            return true;
        }

        // Remove "<timePeriod> experience in", "experience in", etc.
        let cleanedName = inputValue;
        let prefixMatched = false;

        const fullPrefixes: string[] = [];

        // Generate all possible variants for each timePeriod
        this.timePeriods.forEach(tp => {
            const base = tp.name.toLowerCase().trim();
            fullPrefixes.push(`${base} experience in`);
            fullPrefixes.push(`${base} experience`);
            fullPrefixes.push(base);
        });

        // Sort by length DESC to prioritize longest match first
        fullPrefixes.sort((a, b) => b.length - a.length);

        for (let i = 0; i < fullPrefixes.length; i++) {
            const prefix = fullPrefixes[i];
            if (cleanedName.startsWith(prefix)) {
                cleanedName = cleanedName.substring(prefix.length).trim();
                prefixMatched = true;
                break;
            }
        }

        if (!prefixMatched && cleanedName.startsWith('experience in ')) {
            cleanedName = cleanedName.substring('experience in '.length).trim();
            prefixMatched = true;
        }

        // If user entered only prefix and nothing else, return false
        if (prefixMatched && (!cleanedName || cleanedName.length < 2)) {
            return false;
        }

        // Compare cleaned skill against roles/fields/display
        const knownRoles = this.allExistingRoles.map(role => role.role.toLowerCase());
        const knownFields = this.allExistingFieldOfStudy.map(fos => fos.fieldOfStudy.toLowerCase());

        for (let i = 0; i < skillsToCheck.length; i++) {
            const item = skillsToCheck[i];
            const role = item.role ? item.role.trim().toLowerCase() : '';
            const field = item.fieldOfStudy ? item.fieldOfStudy.trim().toLowerCase() : '';
            const display = item.displayName ? item.displayName.toLowerCase() : '';

            if ((role && role === cleanedName && knownRoles.includes(role)) ||
                (field && field === cleanedName && knownFields.includes(field)) ||
                (display && display.includes(cleanedName))) {
                this.existingDuplicateSkillName = {
                    name: cleanedName,
                    type: 'experience',
                    label: 'Experience'
                };
                return true;
            }
        }

        return false;
    }

    extractExactMatch(display: string, value: string): string {
        const regex = new RegExp(`\\b(${value})\\b`, 'i'); // match whole word, case-insensitive
        const match = display.match(regex);
        return match ? match[1] : value;
    }

    escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // escape all special regex chars
    }

    displayExistingSkillMessage(inputText, displayName, successCallback) {
        let name = this.extractExactMatch(inputText, displayName.name);
        if (this.skillType === 'technical' || this.skillType === 'operational' || this.skillType === 'soft' || this.skillType === 'other') {
            this.alertsAndNotificationsService.showAlertWithCallBack('Duplicate Skill', `'<b>${(name)}</b>'` + ' Skill already exists' + `${displayName.label ? ' in ' + `'<b>${displayName.label}</b>'` + ' category.' : "."}`, 'warning', () => {
                if (this.isJobProfile) {
                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
                if (successCallback) {
                    successCallback();
                }
            });
        } else {
            const title = this.skillType === 'education' ? 'Education' : this.skillType === 'experience' ? 'Experience' : 'Certification';
            this.alertsAndNotificationsService.showAlertWithCallBack(`Duplicate ${title}`, `'<b>${(name)}</b>'` + ' already exists.', 'warning', () => {
                if (this.isJobProfile) {
                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
                if (successCallback) {
                    successCallback();
                }
            });
        }
    }
}
